import { render, staticRenderFns } from "./DocumentsCommonList.vue?vue&type=template&id=3462d708&scoped=true&"
import script from "./DocumentsCommonList.vue?vue&type=script&lang=js&"
export * from "./DocumentsCommonList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsCommonList.vue?vue&type=style&index=0&id=3462d708&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3462d708",
  null
  
)

export default component.exports